<template>
    <v-banner
        v-if="showBanner"
        class="cookie-banner tw-px-8 tw-py-4"
        density="compact"
        elevation="24"
        location="bottom"
        position="fixed">
        <template #text>
            <div class="tw-space-y-1">
                <div class="tw-font-semibold tw-text-white">{{ $t('cookieBanner.title') }}</div>
                <div class="tw-text-sm tw-font-light tw-text-white">{{ $t('cookieBanner.message') }}</div>
            </div>
        </template>

        <template #actions>
            <!-- <v-btn
                class="tw-text-xs tw-font-light"
                color="white"
                elevation="0"
                height="2rem"
                rounded="pill"
                variant="outlined"
                @click="openSettings">
                {{ $t('cookieBanner.learnMore') }}
            </v-btn> -->
            <v-btn
                class="tw-ml-2 tw-text-xs tw-font-light"
                color="white"
                elevation="0"
                height="2rem"
                rounded="pill"
                variant="text"
                @click="rejectAll">
                {{ $t('cookieBanner.rejectAll') }}
            </v-btn>
            <v-btn
                class="tw-ml-2 tw-text-xs tw-font-light"
                color="white"
                elevation="0"
                height="2rem"
                rounded="pill"
                variant="outlined"
                @click="acceptAll">
                {{ $t('cookieBanner.acceptAll') }}
            </v-btn>
        </template>
    </v-banner>

    <v-dialog
        v-model="settingsDialog"
        max-width="600"
        scrollable>
        <v-card
            prepend-icon="mdi-cookie-settings"
            :title="$t('cookieBanner.title')">
            <v-card-text class="tw-pt-4">
                <div class="tw-space-y-4">
                    <div>
                        <div class="tw-mb-2 tw-flex tw-items-center tw-justify-between">
                            <div class="tw-font-semibold">{{ $t('cookieBanner.analytics') }}</div>
                            <v-switch
                                v-model="analyticsEnabled"
                                color="primary"
                                density="compact"
                                hide-details></v-switch>
                        </div>
                        <div class="tw-text-gray-600 tw-text-sm">
                            {{ $t('cookieBanner.analyticsDescription') }}
                        </div>
                    </div>
                </div>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="gray"
                    rounded="pill"
                    variant="flat"
                    @click="settingsDialog = false">
                    {{ $t('shared.cancel') }}
                </v-btn>
                <v-btn
                    color="primary"
                    rounded="pill"
                    variant="flat"
                    @click="saveSettings">
                    {{ $t('shared.save') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script setup lang="ts">
    import { computed, ref, watch } from 'vue';
    import { useCookiesStore } from '@/store/cookies';
    import { useGoogleAnalytics } from '@/composables/useGoogleAnalytics';

    const cookiesStore = useCookiesStore();
    const { initialize } = useGoogleAnalytics();

    const showBanner = computed(() => cookiesStore.hasConsent === null);
    const settingsDialog = ref(false);
    const analyticsEnabled = ref(cookiesStore.isAnalyticsEnabled);

    watch(
        () => cookiesStore.isAnalyticsEnabled,
        (newValue) => {
            analyticsEnabled.value = newValue;
        },
    );

    function acceptAll() {
        cookiesStore.acceptAll();
        initialize();
    }

    function rejectAll() {
        cookiesStore.rejectAll();
    }

    function openSettings() {
        analyticsEnabled.value = cookiesStore.isAnalyticsEnabled;
        settingsDialog.value = true;
    }

    function saveSettings() {
        cookiesStore.setAnalyticsEnabled(analyticsEnabled.value);
        cookiesStore.setConsent(true);
        settingsDialog.value = false;
        initialize();
    }
</script>

<style scoped lang="scss">
    .cookie-banner {
        z-index: 9999;
        background-position: top !important;
        background-size: cover !important;
        background-repeat: no-repeat !important;
        background-color: rgba(var(--v-theme-blue-400), 1) !important;
        background-image: url('@/assets/gradients/gradient-background.png') !important;
    }

    .cookie-banner :deep(.v-banner__text) {
        color: white;
    }
</style>
